// Resource.jsx
import React from "react";
import { Skeleton } from "antd";

const Resource = (props) => {
  let data = props.computeData;

  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.computPowerId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    const url = `/computa_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };
  const cpus = [
    { key: 1, value: "1核(vCPU)" },
    { key: 2, value: "2核(vCPU) " },
    { key: 3, value: "4核(vCPU)" },
    { key: 4, value: "8核(vCPU)" },
    { key: 5, value: "16核(vCPU)" },
    { key: 6, value: "32核(vCPU)" },
    { key: 7, value: "48核(vCPU)" },
  ];
  const neics = [
    { key: 1, value: "2GiB" },
    { key: 2, value: "4GiB " },
    { key: 3, value: "8GiB" },
    { key: 4, value: "16GiB" },
    { key: 5, value: "32GiB" },
    { key: 6, value: "64GiB" },
    { key: 7, value: "128GiB" },
    { key: 8, value: "256GiB" },
    { key: 9, value: "512GiB" },
  ];
  return (
    <div className="child-component">
      {data && data.length > 0 ? (
        data.map((v, index) => (
          <div
            key={v.computPowerId}
            className="child-block"
            onClick={() => toDetail(v)}
          >
            <div className="child-block-top">{v.gpu}</div>
            <div className="child-block-bottom">
              <div className="dic">{v.systemEnvironment}</div>
              <div className="dic">
                CPU:
                {v.cpu ? cpus.find((item) => item.key === v.cpu).value : ""}
              </div>
              <div className="dic">
                内存:
                {v.memory
                  ? neics.find((item) => item.key === v.memory).value
                  : ""}
              </div>
              <div className="pic">
                <span>数量：{v.shul}</span>
                <span>
                  {v.hirePrice}￥/
                  {v.hireType === 1 ? "天" : v.hireType === 2 ? "月" : "年"}
                </span>
              </div>
              <div className="mor"></div>
            </div>
          </div>
        ))
      ) : (
        <Skeleton active paragraph={{ rows: 4 }} />
      )}
    </div>
  );
};

export default Resource;
